import { Injectable } from '@angular/core';

import {
  BackendService,
  ApiService,
  SharedObjectBaseService,
  RequestOptionsArgs,
} from '@hub-components';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportsResponse } from '../models/reports-response.model';
import { Report, ReportJson } from '../models/report.model';

@Injectable({
  providedIn: 'root',
})
export class SharedReportsService extends SharedObjectBaseService {
  constructor(
    private backendService: BackendService,
    private apiService: ApiService,
  ) {
    super();
  }

  public list(options: RequestOptionsArgs = {}): Observable<ReportsResponse> {
    return this.backendService
      .load('/shared_reports', options)
      .pipe(
        map((response: { reports: ReportJson[], reports_count: number }) => {
          return {
            reports: response.reports.map(report => new Report(report)),
            reportsCount: response.reports_count,
          };
        }),
      );
  }

  public sharedObject(uuid) {
    return this.apiService
      .load(`/shared_objects/${uuid}`, { skipLoader: true, throwErrors: true });
  }

  public create(reportId, permissions, invites, note, skip) {
    return this.backendService
      .create('/shared_reports', { share: { shared_object_id: reportId, report_id: reportId, app: 'reports', note, skip, invites, dates: permissions.dates } });
  }

  public update(shareUuid: string, payload: any) {
    return this.apiService
      .update(`/shared_objects/${shareUuid}`, { payload }, { skipLoader: true });
  }

  public add(shareUuid, invites: any[], note, skip) {
    return this.backendService
      .create(`/shared_reports/${shareUuid}/invites`, { share: { invites, note, skip } });
  }

  public remove(shareUuid, invite) {
    return this.backendService.delete(`/shared_reports/${shareUuid}/invites/${invite}`);
  }
}
